import { DiscountRestriction, SubscriptionBillingOptionPriceRestriction } from '@vista-digital/ocapi-types/v1';
import { isEmptyArray } from '../../../../utils/array-utils';
import { logger } from '../../../../utils/logger';
import { getDiscountById } from '../../selectors/discounts/get-discount-by-id';
import { isVoucherDiscount, isVoucherDiscountAvailable } from '../voucher-utils';
export const isSubscriptionBillingOptionPriceAvailable = (price) => {
    const exclusiveRestrictions = price.restrictions.filter(isRestrictionExclusive);
    if (exclusiveRestrictions.length > 1)
        return false;
    return price.restrictions.every(restriction => {
        switch (restriction) {
            case SubscriptionBillingOptionPriceRestriction.Discount:
                return isDiscountSubscriptionBillingOptionPriceAvailable(price);
            default:
                logger.warn(`Cannot sell billing option '${price}' with unknown restriction '${restriction}'.`);
                return false;
        }
    });
};
/**
 * We do not support combinations of some restrictions, so we consider them to be exclusive.
 * If a price has multiple exclusive restrictions, we filter it out.
 */
const isRestrictionExclusive = (restriction) => {
    switch (restriction) {
        case SubscriptionBillingOptionPriceRestriction.Discount:
            return true;
        default:
            return false;
    }
};
const isRestrictedDiscountSubscriptionBillingOptionPriceAvailable = (discount, restriction) => {
    switch (restriction) {
        case DiscountRestriction.MemberReward:
            return false; // Not yet supported.
        case DiscountRestriction.Voucher:
            return isVoucherDiscountAvailable(discount.voucherTypeCodes);
        default:
            logger.warn(`Cannot evaluate discount for unknown discount restriction '${restriction}'.`);
            return false;
    }
};
export const isDiscountSubscriptionBillingOptionPriceAvailable = (price) => {
    const discount = getDiscountById(price.discountId);
    if (!discount)
        return false;
    if (isEmptyArray(discount.restrictions))
        return true;
    return discount.restrictions.every(restriction => isRestrictedDiscountSubscriptionBillingOptionPriceAvailable(discount, restriction));
};
export const isDiscountSubscriptionBillingOptionPrice = (optionPrice) => optionPrice.restrictions.includes(SubscriptionBillingOptionPriceRestriction.Discount);
export const isVoucherSubscriptionBillingOptionPrice = (price) => {
    if (!isDiscountSubscriptionBillingOptionPrice(price))
        return false;
    const discount = getDiscountById(price.discountId);
    if (!discount || !isVoucherDiscount(discount) || !isVoucherDiscountAvailable(discount.voucherTypeCodes)) {
        return false;
    }
    return true;
};
//# sourceMappingURL=subscription-billing-option-price-utils.js.map